/**
 * Checks whether a URL (full or relative) points to app.dib.no.
 */
export function isDibContentUrl(href: string): boolean {
    return toInternalPath(href) !== null;
}

/**
 * Converts any app.dib.no URL to an internal route path.
 *
 * Accepts:
 *   - Full URLs:    https://app.dib.no/tema/some-slug/some-id
 *   - Relative:     tema/some-slug/some-id
 *
 * Returns e.g. `/tema/some-slug/some-id`, or `null` if the URL
 * does not point to app.dib.no.
 */
export function toInternalPath(href: string): string | null {
    if (!href) return null;

    try {
        // Handle relative paths by prepending a base
        const url = href.startsWith("http")
            ? new URL(href)
            : new URL(href, "https://app.dib.no");

        // Only match app.dib.no host (covers both full URLs and our synthetic base)
        if (url.hostname !== "app.dib.no") return null;

        return url.pathname;
    } catch {
        // Invalid URL — not a match
    }

    return null;
}
